import {
  ApeironButtonDisableTip,
  DEFAULT_ANIMATE_DURATION,
  MayNull
} from '@apeiron/temp'
import { Button, ButtonProps, styled } from '@mui/material'
import { FC } from 'react'

const StyledButton = styled(Button)`
  background-color: unset;
  border-radius: 4px;
  border: 2px solid #1d66bf;
  color: white;
  font-size: 16px;
  padding: 10px 25px;
  text-transform: none;
  transition: ${DEFAULT_ANIMATE_DURATION}ms;
  :focus {
    background-color: unset;
  }
  :hover {
    background-color: unset;
    filter: brightness(1.2);
  }
  :disabled {
    background-color: unset;
    color: white;
    opacity: 0.5;
    pointer-events: all;
    :active {
      pointer-events: none;
    }
  }
`

const ApeironBorderButton: FC<Props> = props => {
  const { disabled, disableReason, ...rest } = props

  return (
    <ApeironButtonDisableTip disabled={disabled} reason={disableReason}>
      <StyledButton disabled={disabled} {...rest} />
    </ApeironButtonDisableTip>
  )
}

type Props = {
  disableReason?: MayNull<string>
} & ButtonProps

export default ApeironBorderButton
